import React from "react";

import clsx from "clsx";

interface Props<T> {
  options: { label: string; value: T }[];
  value: T;
  onChange: (value: T) => void;
}

export const ButtonGroup = <T extends string>({
  options,
  value,
  onChange,
}: Props<T>) => {
  return (
    <div className="flex items-stretch h-8 text-xs">
      {options.map((option) => (
        <div
          key={option.value}
          className={clsx(
            "flex-1 flex items-center justify-center cursor-pointer",
            "border mr-[-1px] px-1 first:rounded-l-md last:rounded-r-md",
            {
              "bg-white hover:bg-cosmic-4 hover:border-cosmic+1 hover:z-[1]":
                option.value !== value,
              "bg-cosmic text-white border-cosmic z-[1]":
                option.value === value,
            },
          )}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};
